import React from 'react';

type VALoadingProps = {
    size?: 'xlarge' | 'large' | 'medium' | 'small';
};

function VALoading(props:VALoadingProps) {
    return(
        <div className="va-loading" data-size={props.size}><div className="inner">로딩중입니다.....</div></div>
    );
}

VALoading.defaultProps = {
    size: 'medium'
};

export default VALoading;